import { PositionInterface } from '@/types';

const degreesToRadians = (degrees: number) => (degrees * Math.PI) / 180;

export const distanceInKmBetweenEarthCoordinates = (pointA: PositionInterface, pointB: PositionInterface) => {
  const { lat: latA, lng: lngA } = pointA;
  const { lat: latB, lng: lngB } = pointB;

  const earthRadiusKm = 6371;

  const dLat = degreesToRadians(latB - latA);
  const dLon = degreesToRadians(lngB - lngA);

  const latBdeg = degreesToRadians(latB);
  const latAdeg = degreesToRadians(latA);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(latAdeg) * Math.cos(latBdeg);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return earthRadiusKm * c;
};
